import React from "react";

import { FilterIcon as Filter } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";

import { RadioGroup, RadioItem } from "./style";

export type TotalFilterType = {
  isKindGroup: boolean;
  isUsage: boolean;
};

export type HttpStatusProps = {
  onChange: (filter: TotalFilterType) => void;
  filter: TotalFilterType;
};

const TotalFilter = (props: HttpStatusProps) => {
  const { onChange, filter } = props;
  const intl = useIntl();

  return (
    <Dropdown.Root id="group_by_type">
      <Dropdown.Trigger>
        <Filter />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="end" avoidCollisions>
          <Dropdown.Label>
            {intl.formatMessage({ id: "group_by_type" })}
          </Dropdown.Label>
          <RadioGroup
            value={filter.isKindGroup ? "on" : "off"}
            onValueChange={v =>
              onChange({ ...filter, isKindGroup: v === "on" })
            }
          >
            <RadioItem id="on" value="on">
              {intl.formatMessage({ id: "on" })}
            </RadioItem>
            <RadioItem id="off" value="off">
              {intl.formatMessage({ id: "off" })}
            </RadioItem>
          </RadioGroup>
          {/* <Dropdown.Separator />
          <Dropdown.Label>{intl.formatMessage({ id: "show" })}</Dropdown.Label>
          <RadioGroup
            value={filter.isUsage ? "usage" : "allocation"}
            onValueChange={v => onChange({ ...filter, isUsage: v === "usage" })}
          >
            <RadioItem value="usage">
              {intl.formatMessage({ id: "usage" })}
            </RadioItem>
            <RadioItem value="allocation">
              {intl.formatMessage({ id: "allocation" })}
            </RadioItem>
          </RadioGroup> */}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default TotalFilter;
